import { Band, CarriedAdjustment, StatementLoan } from '../types/commission';

export const statementMeta = {
  loanOfficer: 'Alex Rivera',
  branch: 'Troy',
  period: 'October 2026',
  units: 7,
  volume: 2485400,
  adjustedVolume: 2238543.08,
};

export const statementOptions = {
  viewAs: [
    { value: 'self', label: 'Alex Rivera (my dashboard)' },
    { value: 'manager-az', label: 'Quinn Harper — Manager, Arizona only' },
  ],
  periods: ['October 2026', 'September 2026', 'August 2026'],
};

/** Troy Standard LO base BPS by the employee's period loan volume (values in $M). */
export const troyBaseBands: Band[] = [
  { label: 'Under $1.5M', from: 0, to: 1.5, valueLabel: '100 bps' },
  { label: '$1.5M or more', from: 1.5, to: null, valueLabel: '125 bps' },
];

export const BASE_RULES_SUMMARY = 'Troy 100, or 125 at ≥ $1.5M · Miami 100, or 150 at ≥ $2M · Arizona flat 100 bps';
export const BONUS_CAP_NOTE = 'Base + bonus can’t exceed 150 bps: bonus = MIN(bonus, 150 − base). Loan Officer fees only.';
export const BONUS_MAIN_NOTE = 'git main CASE pays 0 at 4–6; prod to be confirmed.';
export const SELF_GEN_BONUS_NOTE = 'Differs from main (main gives 0 when LO = loan’s Team Leader); Zeyad confirms bonus applies.';
export const TIER_LABEL_NOTE = 'Tier label (quarter snapshot) – display only, does not affect pay';

/** Monthly bonus BPS by count of closed loans in the month — Loan Officer fees only. */
export const monthlyBonusBands: Band[] = [
  { label: '0–3 closed', from: 0, to: 4, valueLabel: 'No bonus' },
  { label: '4–5 closed', from: 4, to: 6, valueLabel: '+15 bps' },
  { label: '6 closed', from: 6, to: 7, valueLabel: '+25 bps' },
  { label: '7+ closed', from: 7, to: null, valueLabel: '+50 bps' },
];

/** All Correspondent, non-HELOC, divisor 3.25%. Base 125 (Troy ≥ $1.5M) + bonus +50 capped to +25 = 150 bps. */
export const statementLoans: StatementLoan[] = [
  {
    loanNumber: 'LN-2026-004655', borrower: 'M. Testerson', fundedDate: 'Oct 2 2026', loanAmount: 285000, adjustedAmount: 285000, baseBps: 125, bonusBps: 25,
    payTotal: 4275, adjustedTotal: 4275,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 3562.5, adjustedAmount: 3562.5 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 712.5, adjustedAmount: 712.5 },
    ],
  },
  {
    loanNumber: 'LN-2026-004701', borrower: 'R. Placeholder', fundedDate: 'Oct 6 2026', loanAmount: 356200, adjustedAmount: 339760, baseBps: 125, bonusBps: 25,
    payTotal: 5343, adjustedTotal: 5096.4,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 4452.5, adjustedAmount: 4247 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 890.5, adjustedAmount: 849.4 },
    ],
  },
  {
    loanNumber: 'LN-2026-004744', borrower: 'D. Example', fundedDate: 'Oct 9 2026', loanAmount: 198800, adjustedAmount: 6221.54, baseBps: 125, bonusBps: 25,
    payTotal: 2982, adjustedTotal: 93.32, negativeComp: true,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 2485, adjustedAmount: 77.77 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 497, adjustedAmount: 15.55 },
    ],
  },
  {
    loanNumber: 'LN-2026-004790', borrower: 'K. Mockley', fundedDate: 'Oct 12 2026', loanAmount: 524000, adjustedAmount: 512969.23, baseBps: 125, bonusBps: 25,
    payTotal: 4716, adjustedTotal: 4616.72, split: { pct: 60, partner: 'Jordan Lee', partnerPct: 40 },
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 3930, adjustedAmount: 3847.27 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 786, adjustedAmount: 769.45 },
    ],
  },
  {
    loanNumber: 'LN-2026-004812', borrower: 'J. Sample', fundedDate: 'Oct 14 2026', loanAmount: 412500, adjustedAmount: 385692.31, baseBps: 125, bonusBps: 25,
    payTotal: 6187.5, adjustedTotal: 5785.38,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 5156.25, adjustedAmount: 4821.15 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 1031.25, adjustedAmount: 964.23 },
    ],
  },
  {
    loanNumber: 'LN-2026-004859', borrower: 'T. Fakename', fundedDate: 'Oct 21 2026', loanAmount: 241600, adjustedAmount: 241600, baseBps: 125, bonusBps: 25,
    payTotal: 3624, adjustedTotal: 3624,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 3020, adjustedAmount: 3020 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 604, adjustedAmount: 604 },
    ],
  },
  {
    loanNumber: 'LN-2026-004903', borrower: 'L. Demo', fundedDate: 'Oct 28 2026', loanAmount: 467300, adjustedAmount: 467300, baseBps: 125, bonusBps: 25,
    payTotal: 7009.5, adjustedTotal: 7009.5,
    lines: [
      { component: 'Base', ruleKey: 'V1-BT-TROY-2', bps: 125, payAmount: 5841.25, adjustedAmount: 5841.25 },
      { component: 'Monthly Bonus', ruleKey: 'V1-MB-3', bps: 25, payAmount: 1168.25, adjustedAmount: 1168.25 },
    ],
  },
];

export const carriedAdjustments: CarriedAdjustment[] = [
  {
    id: 'ADJ-2026-09-0117',
    sourcePeriod: 'September 2026',
    loanNumber: 'LN-2026-004398',
    borrower: 'P. Sampleton',
    reason: 'Loan amount corrected $310,000.00 → $318,000.00 after September locked. $8,000.00 × (125 + 25 bps, bonus capped) = $120.00.',
    postedOn: 'Oct 8 2026',
    amount: 120,
  },
  {
    id: 'ADJ-2026-08-0042',
    sourcePeriod: 'August 2026',
    loanNumber: 'LN-2026-003915',
    borrower: 'H. Testcase',
    reason: 'Alex had 4 closed loans in August = +15 bps (V1-MB-1): +25 paid, +15 correct, $240,000.00 × 0.10% reversed.',
    postedOn: 'Oct 4 2026',
    amount: -240,
  },
];
